import { Component, OnDestroy, OnInit } from '@angular/core'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { Subscription } from 'rxjs'
import { OrderPipe } from 'ngx-order-pipe'
import { ModalDismissReasons, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap'

import { ProfileService } from 'src/app/shared/profile.service'
import { NotificationService } from './../../shared/notification.service'
import { LoginService } from 'src/app/shared/login.service'

import { Empresa } from 'src/app/models/empresa.model'

import { EmpresaService } from './empresas.service'

@Component({
	selector: 'app-empresas',
	templateUrl: './empresas.component.html',
	styleUrls: ['./empresas.component.scss'],
})
export class EmpresasComponent implements OnInit, OnDestroy {
	title = 'EMPRESAS'
	dynamicUrl = '/empresas'

	empresa: Empresa = new Empresa()
	empresas: Array<Empresa> = []
	empresasInativas: Array<Empresa> = []
	tipoEmpresa = ['Patrocinadora', 'Consignataria', 'Empresa Parceira']
	dataSaved = false
	infoMessage = { status: 0, message: '' }

	createEmpresaForm: FormGroup
	updateEmpresaForm: FormGroup
	deleteEmpresaForm: FormGroup
	modalRef: NgbModalRef
	closeResult: string

	// search
	_listFilter: string
	filtered: Array<Empresa> = []

	// paginação
	page = 1
	pageSize = 15
	collectionSize: number
	pagefiltered: Array<Empresa> = []
	order: string = 'codigo'
	key: string = 'codigo'
	reverse: boolean = false
	onSort(key) {
		this.key = key
		this.reverse = !this.reverse
	}

	perfilNormativo = false
	perfilTecnico = false
	loginDisplay = false

	private subscriptions: Subscription[] = []

	constructor(
		private empresaService: EmpresaService,
		private orderPipe: OrderPipe,
		private modalService: NgbModal,
		private formBuilder: FormBuilder,
		private perfilService: ProfileService,
		private loginService: LoginService,
		private notificationService: NotificationService
	) {
		this.createForm()
		this.updateForm()
		this.deleteForm()

		this.orderPipe.transform(this.empresas, this.order)
		this.orderPipe.transform(this.pagefiltered, this.order)
	}

	ngOnInit(): void {
		this.subscriptions.push(
			this.loginService.user$.subscribe((user) => {
				this.loginDisplay = !!user
				if (user) {
					this.perfilService.verificarPerfis()
					this.carregarPerfis()
					this.getEmpresas()
				}
			}),
			this.loginService.error$.subscribe((error) => {
				this.infoMessage.message = error || ''
			})
		)
	}

	carregarPerfis() {
		this.perfilNormativo = this.perfilService.getPerfilNormativo()
		this.perfilTecnico = this.perfilService.getPerfilTecnico()
	}

	get listFilter(): string {
		return this._listFilter
	}

	set listFilter(value: string) {
		this.filtered = this.empresas
		this._listFilter = value
		this.filtered = this.listFilter ? this.onFilter(this.listFilter) : this.empresas
		this.collectionSize = this.filtered.length
		this.pagefiltered = this.filtered

		this.refreshPage()
	}

	onFilter(text: string): Array<Empresa> {
		return this.empresas.filter((empresa) => {
			const term = text.toLowerCase()
			return empresa.nome_completo.toLowerCase().includes(term) || empresa.tipo.toLowerCase().includes(term) || empresa.codigo.toLowerCase().includes(term)
		})
	}

	refreshPage() {
		this.pagefiltered = this.listFilter
			? this.filtered
					.map((empresa, i) => ({ index: i + 1, ...empresa }))
					.slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize)
			: this.empresas
					.map((empresa, i) => ({ index: i + 1, ...empresa }))
					.slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize)
	}

	cleanFiltered() {
		this.collectionSize = this.empresas.length
		this.listFilter = ''
		this.refreshPage()
	}

	getEmpresas() {
		this.infoMessage.status = 2
		this.empresaService.getEmpresas().subscribe((res) => {
			if (res.status >= 400) {
				this.notificationService.showMessage(res.status, res.message, 'create', this.dynamicUrl)
				this.onDismiss()
			} else {
				if (res._count == 0) {
					this.infoMessage = { status: 1, message: 'Não existem empresas cadastradas!' }
				} else {
					this.infoMessage.status = 3
					this.empresas = res.empresas.filter((emp) => emp.status === 'ativo')
					this.empresasInativas = res.empresas.filter((emp) => emp.status === 'inativo')
					this.collectionSize = this.empresas.length
					this.refreshPage()
				}
			}
		})
	}

	onChange(event, form) {
		if (event.target.value) form.tipo = event.target.value
	}

	create(form) {
		this.openModal(form)
		this.createEmpresaForm.patchValue({
			id: '',
			codigo: '',
			nome_completo: '',
			tipo: '',
			status: 'ativo',
		})
	}

	createForm() {
		this.createEmpresaForm = this.formBuilder.group({
			codigo: new FormControl('', Validators.required),
			nome_completo: new FormControl('', Validators.required),
			tipo: new FormControl('', Validators.required),
			status: new FormControl('ativo'),
		})
	}

	onCreate(form) {
		let empresa = JSON.parse(JSON.stringify(form.value))
		if (!this.empresasInativas.find((emp) => emp.codigo == empresa.codigo)) {
			empresa.status = 'ativo'
			this.empresaService.create(empresa).subscribe(
				(res) => {
					this.dataSaved = true
					this.getEmpresas()
					this.createEmpresaForm.reset()
					if (res.status >= 400 || res.status == 0) {
						this.notificationService.showMessage(res.status, `Verifique as informações: ${res.statusText} `, 'create', this.dynamicUrl)
						this.onDismiss()
					} else {
						this.notificationService.showMessage(res.status, 'Empresa cadastrada com Sucesso!', 'create', this.dynamicUrl)
						this.onDismiss()
					}
				},
				(error) => {
					this.notificationService.showMessage(error, error.message, 'create', this.dynamicUrl)
					this.onDismiss()
				}
			)
		} else {
			this.notificationService.showMessage(400, 'Código já utilizado, empresa inativa.', 'create', this.dynamicUrl)
			this.onDismiss()
		}
	}

	update(empresa: Empresa, form) {
		this.openModal(form)
		this.updateEmpresaForm.patchValue({
			id: empresa.id,
			codigo: empresa.codigo,
			nome_completo: empresa.nome_completo,
			tipo: empresa.tipo,
			status: empresa.status,
		})
		this.empresa = empresa
		this.cleanFiltered()
	}

	updateForm() {
		this.updateEmpresaForm = this.formBuilder.group({
			id: new FormControl(''),
			codigo: new FormControl({ disabled: true }),
			nome_completo: new FormControl('', Validators.required),
			tipo: new FormControl('', Validators.required),
			status: new FormControl('', Validators.required),
		})
	}

	onUpdate(form) {
		this.empresa = form.value
		this.empresaService.update(this.empresa).subscribe(
			(res: any) => {
				this.notificationService.showMessage(res.status, res.mensagem, 'update', this.dynamicUrl)
				this.onDismiss()
			},
			(error) => {
				this.notificationService.showMessage(error, error.message, 'update', this.dynamicUrl)
				this.onDismiss()
			}
		)
	}

	delete(empresa, form) {
		this.openModal(form)
		this.deleteEmpresaForm.patchValue({
			id: empresa.id,
			codigo: empresa.codigo,
			nome_completo: empresa.nome_completo,
			tipo: empresa.tipo,
			status: empresa.status,
		})
		this.empresa = empresa
		this.cleanFiltered()
	}

	deleteForm() {
		this.deleteEmpresaForm = this.formBuilder.group({
			id: [{ value: '', disabled: true }],
			codigo: [{ value: '', disabled: true }],
			nome_completo: [{ value: '', disabled: true }],
			tipo: [{ value: '', disabled: true }],
		})
	}

	onDelete(form) {
		this.empresa = JSON.parse(JSON.stringify(form.value))
		this.empresa.status = 'inativo'
		this.empresaService.update(this.empresa).subscribe(
			(res: any) => {
				this.notificationService.showMessage(res.status, 'Empresa deletada com sucesso!', 'delete', this.dynamicUrl)
				this.onDismiss()
			},
			(error) => {
				this.notificationService.showMessage(error, error.message, 'delete', this.dynamicUrl)
			}
		)
	}

	openModal(form) {
		this.modalRef = this.modalService.open(form)
		this.modalRef.result.then(
			(result) => {
				this.closeResult = `Closed with: ${result}`
			},
			(reason) => {
				this.closeResult = `Dismissed ${this.getDismissReason(reason)}`
			}
		)
	}

	private getDismissReason(reason: any): string {
		if (reason === ModalDismissReasons.ESC) {
			return 'Pressione ESC para sair'
		} else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
			return 'Click OK para executar a tarefa'
		} else {
			return `with: ${reason}`
		}
	}

	onDismiss() {
		this.modalRef.dismiss()
		this.cleanFiltered()
		this.getEmpresas()
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach((sub) => sub.unsubscribe())
	}
}
